module.exports = __webpack_public_path__ + "img/seal.1a37d3fd.png";